export enum CartItemType {
    plan,
    item
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/shared/enums/CartItemType.ts